import { BASE_URL } from "../constants";

export function buildRedirectURL(route: string, preserveQueryString: boolean) {
  return `${BASE_URL}${route}${preserveQueryString ? window.location.search : ""}`;
}
